import { Flame } from 'lucide-react';
import { Link } from 'react-router-dom';
export default function Footer() {
  return (
    <footer className="border-t border-white/[0.04] mt-auto">
      <div className="max-w-5xl mx-auto px-4 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-sm text-gray-500"><Flame size={14} className="text-burner-500" /><span>Burner Codes</span><span className="text-zinc-700">|</span><span>a Faraday company</span></div>
          <div className="flex items-center gap-5 text-xs text-gray-500">
            <Link to="/about" className="hover:text-gray-300 transition-colors">About</Link>
            <Link to="/faq" className="hover:text-gray-300 transition-colors">FAQ</Link>
            <span className="text-zinc-700">802 East Whiting St, Tampa FL 33602</span>
          </div>
        </div>
        <div className="mt-4 flex justify-center"><span className="text-[10px] text-zinc-600 bg-zinc-900/50 px-3 py-1 rounded-full border border-zinc-800/50">Powered by KrossTawk</span></div>
      </div>
    </footer>
  );
}
